import React from 'react';
import { Link } from 'react-router-dom';
import './Service.scss';

const Service = ({ serviceList }) => {
  const { title, type } = serviceList;
  
  return (
    <div className={`service-card-container ${type === 'yellow' ? 'service-card-container-yellow' : ''}`}>
      <Link to={`/oferta/#${serviceList.id}`}>
      <div className={`service-card ${type === 'yellow' ? 'service-card-yellow' : ''}`}>
        <div className={`service-content ${type === 'yellow' ? 'service-content-yellow' : ''}`}>
          <h3>{title}</h3>
          <div className="divider"></div>
          <div className="card-footer">
            <div className="read-more">
              Więcej
              <svg className="arrow-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M13.5 5L21 12M21 12L13.5 19M21 12H3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
          </div>
        </div>
      </div>
      </Link>
    </div>
  );
};

export default Service;